export var STATE_VALUE_ENUM;

!function(STATE_VALUE_ENUM) {
    STATE_VALUE_ENUM.STATE_NORMAL = "normal", STATE_VALUE_ENUM.STATE_HOVER = "hover", 
    STATE_VALUE_ENUM.STATE_HOVER_REVERSE = "hover_reverse", STATE_VALUE_ENUM.STATE_DIMENSION_HOVER = "dimension_hover", 
    STATE_VALUE_ENUM.STATE_DIMENSION_HOVER_REVERSE = "dimension_hover_reverse", STATE_VALUE_ENUM.STATE_SELECTED = "selected", 
    STATE_VALUE_ENUM.STATE_SELECTED_REVERSE = "selected_reverse", STATE_VALUE_ENUM.STATE_SANKEY_EMPHASIS = "selected", 
    STATE_VALUE_ENUM.STATE_SANKEY_EMPHASIS_REVERSE = "blur", STATE_VALUE_ENUM.STATE_HIGHLIGHT = "highlight", 
    STATE_VALUE_ENUM.STATE_BLUR = "blur", STATE_VALUE_ENUM.STATE_ACTIVE = "active";
}(STATE_VALUE_ENUM || (STATE_VALUE_ENUM = {}));

export var STATE_VALUE_ENUM_REVERSE;

!function(STATE_VALUE_ENUM_REVERSE) {
    STATE_VALUE_ENUM_REVERSE.STATE_HOVER_REVERSE = "hover_reverse", STATE_VALUE_ENUM_REVERSE.STATE_DIMENSION_HOVER_REVERSE = "dimension_hover_reverse", 
    STATE_VALUE_ENUM_REVERSE.STATE_SELECTED_REVERSE = "selected_reverse";
}(STATE_VALUE_ENUM_REVERSE || (STATE_VALUE_ENUM_REVERSE = {}));
//# sourceMappingURL=interface.js.map
